module.exports = __webpack_public_path__ + "img/symbol_2.a44da6f7.png";